export const CHANGE_BALANCE = "CHANGE_BALANCE";
export const CREATE_NEW_ADDRESS = "CREATE_NEW_ADDRESS";
export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
